export const getCustomers = `query Customer {
    customers { 
      id
      name
    }
  }
  `;
